const doc = [[({"img":"pink-pjs-hero@3x.png", "overlay":false}), ({"img":"pink-harness-hero@3x.png", "overlay":false})]];
module.exports = doc.length <= 1 ? doc[0] : doc;